import type { definitions } from '@luxuryescapes/contract-svc-agent'

type ServerAgentAccount = definitions['userSimpleSchema'] | definitions['meSchema']
type ServerAgencyDetails = definitions['userWithAgencyResponse']
type ServerAgentEmailStatus = definitions['userStatusResponse']

export function agentHubCheckEmailStatusMapper(response: ServerAgentEmailStatus): App.AgentHubAgentStatusData {
  return {
    status: response.status ?? '',
    agentId: response.agent_id ?? '',
    action: response.action,
    customerId: response.customer_id,
    ...(response.email && { email: response.email }),
    ...(response.firstName && { firstName: response.firstName }),
    ...(response.surname && { surname: response.surname }),
    ...(response.phone && { phone: response.phone }),
    ...(response.phone_prefix && { phonePrefix: response.phone_prefix }),
  }
}

export function agentHubAccountMapper(response: ServerAgentAccount): App.AgentHubAccount {
  return {
    agentId: response.id,
    name: response.name ?? '',
    phone: response.phone ?? '',
    email: response.email ?? '',
    affiliation: response.affiliation,
    affiliationId: response.affiliationId ?? '',
    agencyId: response.agencyId ?? '',
    agencyName: response.agencyName ?? '',
    status: response.status as 'onboarded' | 'pending',
    agencyLogoId: response.agencyLogoId,
    agentTier: response.tier || 'tier1',
    hasAgencyIdentifier: ('hasAgencyIdentifier' in response) ? response.hasAgencyIdentifier : false,
    agentHasPayoutAccountSetup: ('hp' in response) ? response.hp : false,
    customerId: response.customerId || '',
    affiliationRules: 'affiliationRules' in response
      ? response.affiliationRules
      : undefined,
    societeMemberNumber: response.societeMemberNumber,
    societeRequestsInteractions: response.societeRequestsInteractions,
  }
}

export function agentHubAgencyMapper(response: ServerAgencyDetails): App.AgentHubAgency {
  return {
    id: response.id,
    name: response.name ?? '',
    agencyIdentifier: response.businessCodeValue,
    agencyIdentifierType: response.businessCodeType,
    address: response.address,
    city: response.city,
    state: response.state,
    postcode: response.postcode,
    country: response.country,
    affiliation: response.affiliation,
    brand: response.brand,
  }
}

export function mapBedbankPackageToAgentHubPayload(rate: App.BedbankRate) {
  return { packageId: rate.id, mx: rate.mx || '' }
}

export function mapLPCPackageToAgentHubPayload(pkg: App.HotelPackage) {
  return {
    packageId: pkg.id,
    mx: pkg.roomRate.mx!,
  }
}

export function mapFlashPackageToAgentHubPayload(pkg: App.HotelPackage) {
  return {
    packageId: pkg.id,
    mx: pkg.mx!,
  }
}
